export default function OwlIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3.6C8.5 3.6 6 6.2 6 9.8v4.6c0 3.4 2.7 6 6 6s6-2.6 6-6V9.8c0-3.6-2.5-6.2-6-6.2Z" />
      <path d="M6.3 6.9 9.6 8.7 12 7.4l2.4 1.3 3.3-1.8" />
      <circle cx="9.6" cy="11.3" r="2" />
      <circle cx="14.4" cy="11.3" r="2" />
      <path d="M11.3 13.7 12 15.1l.7-1.4Z" />
      <path d="M6.3 13.8c1.3.9 2 2.4 2 4.2M17.7 13.8c-1.3.9-2 2.4-2 4.2" />
      <circle fill="currentColor" stroke="none" cx="9.6" cy="11.3" r=".8" />
      <circle fill="currentColor" stroke="none" cx="14.4" cy="11.3" r=".8" />
    </svg>
  );
}
